import * as angular from 'angular';

import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";
import { downgradeInjectable } from "@angular/upgrade/static";

import { HttpService } from '../../shared/ajs-bridges/http.service';

@Injectable({ providedIn: 'root' })
export class SecurityService {
	private path: string;

	constructor( //
		@Inject(HttpService) private httpService: HttpService, //
		@Optional() @SkipSelf() previousInstance?: SecurityService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		// ATTENTION: Ce service n'utilise pas la meme racine que les autres
		// La raison est que la resource qu'il utilise ne necessite pas d'etre authentifiee pour etre accedee
		// Alors que toutes les resources sous /api/* sont filtrees par le module de securite Java
		this.path = (window as any).securityPath;
	}
	
	// Methode retro-compatible angular-js pour le ping
	public doPing(): Promise<any> {
		let url = this.path + 'ping';
		return this.httpService.get(url);
	};
}

angular
	.module('auroraApp')
	.service('securityService', downgradeInjectable(SecurityService));